import { parsePlanDoc } from '@db/Plans/Common';
import db from '@helpers/firebase/Firestore';
import { firestore } from '@helpers/firebase/Initialize';
import { Plan } from '@types';

export function listenToUserPlans(
  userId: string,
  onPlans: (plans: Plan[]) => void,
  onError: (error: db.FirestoreError) => void,
  constraints: db.QueryConstraint[] = []
) {
  const q = db.query(
    db.collection(firestore, 'plans'),
    db.where('userId', '==', userId),
    ...constraints
  );
  const onNext = (snap: db.QuerySnapshot) => {
    const plans = snap.docs.map((doc) => parsePlanDoc(doc));
    return onPlans(plans);
  };
  return db.onSnapshot(q, onNext, onError);
}

export function listenToUserJoinedPlans(
  userId: string,
  onPlans: (plans: Plan[]) => void,
  onError: (error: db.FirestoreError) => void,
  constraints: db.QueryConstraint[] = []
) {
  const q = db.query(
    db.collection(firestore, 'plans'),
    db.where('userIds', 'array-contains', userId),
    ...constraints
  );
  const onNext = (snap: db.QuerySnapshot) => {
    const plans = snap.docs.map((doc) => parsePlanDoc(doc));
    return onPlans(plans);
  };
  return db.onSnapshot(q, onNext, onError);
}
